/* Chippys PDP: gallery, pack-size variant selection, real Shopify add to cart, sticky buy bar */
(function () {
  'use strict';
  document.querySelectorAll('[data-chp-product]').forEach(function (root) {
    // ---------- Gallery ----------
    var stage = root.querySelector('#chp-stage-image');
    var thumbs = root.querySelectorAll('.thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!stage || !thumb.dataset.src) return;
        stage.removeAttribute('srcset');
        stage.src = thumb.dataset.src;
        stage.alt = thumb.dataset.alt || '';
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
          t.setAttribute('aria-selected', t === thumb ? 'true' : 'false');
        });
      });
    });

    // ---------- Pack selection ----------
    var form = root.querySelector('form[data-chp-form]');
    if (!form) return;
    var inputs = form.querySelectorAll('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var unitEl = root.querySelector('[data-price-unit]');
    var ctaLabel = root.querySelector('[data-cta-label]');
    var ctaBtn = form.querySelector('.purchase__cta');
    var shipEl = root.querySelector('[data-ship-line]');
    var stickyName = root.querySelector('[data-sticky-name]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var errEl = root.querySelector('[data-chp-error]');

    function selected() { return form.querySelector('input[name="id"]:checked'); }

    function update() {
      var input = selected();
      if (!input) return;
      form.querySelectorAll('.pack-card').forEach(function (card) {
        var i = card.querySelector('input[name="id"]');
        card.classList.toggle('is-active', i && i.checked);
      });
      var d = input.dataset;
      if (priceEl) priceEl.textContent = d.price;
      if (unitEl) unitEl.textContent = d.variantTitle + ' · ' + d.per + '/bag';
      if (ctaLabel) ctaLabel.textContent = 'Add ' + d.variantTitle + ' to cart · ' + d.price;
      if (ctaBtn) ctaBtn.disabled = input.disabled;
      if (shipEl && d.shipCopy) shipEl.textContent = d.shipCopy;
      if (stickyName) stickyName.textContent = 'Chippys · ' + d.variantTitle;
      if (stickyPrice) stickyPrice.textContent = d.price;
      var stageImg = root.querySelector('#chp-stage-image');
      if (d.image && stageImg && !update.first) {
        stageImg.removeAttribute('srcset');
        stageImg.src = d.image;
        stageImg.alt = d.imageAlt || '';
        var packThumb = root.querySelector('[data-pack-thumb]');
        if (packThumb) {
          packThumb.dataset.mediaId = d.mediaId; packThumb.dataset.src = d.image; packThumb.dataset.alt = d.imageAlt || '';
          var pti = packThumb.querySelector('img'); if (pti && d.thumb) { pti.removeAttribute('srcset'); pti.src = d.thumb; }
        }
        root.querySelectorAll('.thumb').forEach(function (t) {
          var on = t.dataset.mediaId === d.mediaId;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      update.first = false;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url.toString());
    }
    update.first = true;
    inputs.forEach(function (i) { i.addEventListener('change', update); });
    if (!selected() && inputs.length) { inputs[0].checked = true; }
    update();

    // ---------- Subscribe & Save ----------
    var sub = (function () {
      var box = root.querySelector('[data-chx-buy-mode]');
      var api = { preview: false, active: function () { return false; }, planId: function () { return ''; }, refresh: function () {} };
      if (!box) return api;
      api.preview = box.hasAttribute('data-preview');
      if (api.preview) {
        var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
        if (role === 'main' || !role) { box.remove(); return api; }
      }
      box.hidden = false;
      var map = {}; try { map = JSON.parse(box.querySelector('[data-chx-sub-map]').textContent || '{}'); } catch (e) {}
      var pct = parseFloat(box.dataset.pct) || 0;
      var freq = box.querySelector('[data-chx-sub-freq]');
      var hidden = box.querySelector('[data-chx-selling-plan]');
      var subOpt = box.querySelector('[data-chx-sub-opt]');
      var subRadio = box.querySelector('input[value="subscribe"]');
      var onceRadio = box.querySelector('input[value="onetime"]');
      var note = box.querySelector('[data-chx-sub-note]');
      function fmt(c) { return '$' + (c / 100).toFixed(2); }
      function subPrice(input) {
        var plans = map[input.value] || {};
        if (api.preview) { return Number(input.dataset.qty) > 2 ? Math.round(Number(input.dataset.priceCents) * (100 - pct) / 100) : null; }
        var id = freq && freq.value; if (id && plans[id] != null) return plans[id];
        var k = Object.keys(plans); return k.length ? plans[k[0]] : null;
      }
      api.active = function () { return subRadio && subRadio.checked; };
      api.planId = function () { return hidden && !hidden.disabled ? hidden.value : ''; };
      api.refresh = function () {
        var input = selected(); if (!input) return;
        var sp = subPrice(input);
        var ok = sp != null;
        if (!ok && subRadio.checked) { onceRadio.checked = true; }
        subRadio.disabled = !ok; subOpt.classList.toggle('is-disabled', !ok);
        if (note) note.hidden = ok;
        box.hidden = !ok;
        box.querySelectorAll('.chx-buy-mode__opt').forEach(function (l) { var r = l.querySelector('input[name="chx_purchase"]'); l.classList.toggle('is-active', r.checked); });
        box.querySelector('[data-chx-once-price]').textContent = input.dataset.price;
        box.querySelector('[data-chx-sub-price]').textContent = ok ? fmt(sp) : '';
        if (api.active() && ok) {
          if (hidden) { hidden.disabled = api.preview; hidden.value = api.preview ? '' : (freq.value || Object.keys(map[input.value] || {})[0] || ''); }
          if (priceEl) priceEl.textContent = fmt(sp);
          if (unitEl) unitEl.textContent = input.dataset.variantTitle + ' · subscribe & save' + (pct ? ' ' + pct + '%' : '');
          if (ctaLabel) ctaLabel.textContent = 'Subscribe · ' + input.dataset.variantTitle + ' · ' + fmt(sp);
          if (stickyPrice) stickyPrice.textContent = fmt(sp);
        } else if (hidden) { hidden.disabled = true; hidden.value = ''; }
      };
      box.addEventListener('change', api.refresh);
      inputs.forEach(function (i) { i.addEventListener('change', api.refresh); });
      api.refresh();
      window.dispatchEvent(new Event('chx:subs-ready'));
      if (location.hash === '#chx-buy-mode') { setTimeout(function () { box.scrollIntoView({ block: 'center' }); }, 300); }
      return api;
    })();

    // ---------- Add to cart (Shopify AJAX cart) ----------
    function addToCart() {
      var input = selected();
      if (!input) return;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      if (ctaBtn) ctaBtn.setAttribute('aria-busy', 'true');
      var cartDrawer = document.querySelector('cart-drawer');
      var cartNotification = document.querySelector('cart-notification');
      var sectionsTarget = cartDrawer || cartNotification;
      var line = { id: Number(input.value), quantity: 1 };
      if (sub.active()) {
        if (sub.preview) {
          if (errEl) { errEl.textContent = 'Preview only: subscriptions turn on once the Shopify Subscriptions app is set up. Pick one-time to test the cart.'; errEl.hidden = false; }
          if (ctaBtn) ctaBtn.removeAttribute('aria-busy');
          return;
        }
        if (sub.planId()) line.selling_plan = Number(sub.planId());
      }
      var body = { items: [line] };
      if (sectionsTarget && typeof sectionsTarget.getSectionsToRender === 'function') {
        body.sections = sectionsTarget.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            throw new Error(res.json.description || res.json.message || 'Could not add to cart.');
          }
          var item = res.json.items ? res.json.items[0] : res.json;
          var payload = Object.assign({}, item, { sections: res.json.sections });
          if (window.ChippysCart) {
            window.ChippysCart.refresh().then(function () { window.ChippysCart.open(); });
          } else if (sectionsTarget && typeof sectionsTarget.renderContents === 'function' && res.json.sections) {
            if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
            sectionsTarget.renderContents(payload);
          } else {
            window.location.href = root_url + 'cart';
          }
        })
        .catch(function (e) {
          if (errEl) { errEl.textContent = e.message; errEl.hidden = false; }
        })
        .finally(function () { if (ctaBtn) ctaBtn.removeAttribute('aria-busy'); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    var stickyAdd = root.querySelector('[data-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });

    // ---------- Sticky buy bar ----------
    var sticky = root.querySelector('[data-sticky-buy]');
    if (sticky && ctaBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && window.innerWidth < 900;
        sticky.dataset.visible = show ? 'true' : 'false';
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { rootMargin: '0px 0px -20% 0px', threshold: 0 }).observe(ctaBtn);
    }
  });
})();

/* Photo hero CTA + pick-your-pack band: select pack and scroll to the buy box */
(function () {
  function buyBox() { return document.querySelector('[data-chp-product]'); }
  function go(el) {
    if (!el) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-chp-scroll-buy]');
    if (cta) { e.preventDefault(); go(buyBox()); return; }
    var btn = e.target.closest('[data-pick-pack]');
    if (!btn) return;
    var box = buyBox();
    var input = box && box.querySelector('input[name="id"][data-qty="' + btn.dataset.pickPack + '"]');
    if (input && !input.disabled) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    go(box);
  });
})();
